import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const MicrosoftIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M15.554 15.553H7V7h8.554v8.553Z"
      fill={preserveColor ? "#F1511B" : undefined}
    />
    <path
      d="M25 15.553h-8.555V7h8.554v8.553Z"
      fill={preserveColor ? "#80CC28" : undefined}
    />
    <path
      d="M15.554 25H7v-8.553h8.554V25Z"
      fill={preserveColor ? "#00ADEF" : undefined}
    />
    <path
      d="M25 25h-8.555v-8.553h8.554V25Z"
      fill={preserveColor ? "#FBBC09" : undefined}
    />
  </BaseIcon>
);
